<div class="emds" [ngClass]="{ required: required, 'required-invalid': form?.submitted && error }">
  <div *ngIf="disabled; else enabled">
    <span>{{displayText}}</span>
  </div>
  <ng-template #enabled>
    <mat-form-field appearance="outline" class="emds-find-control" (click)="openModal()">
      <mat-chip-list #chipList matPrefix>
        <mat-chip *ngIf="isLoading">
          <ap-spinner size="1"></ap-spinner>
        </mat-chip>
      </mat-chip-list>
      <input
        matInput
        [(ngModel)]="displayText"
        (ngModelChange)="onChange($event)"
        [matChipInputFor]="chipList"
        [readonly]="true"
        class="emds-find-control-text-input text-only"
        [ngClass]="{ 'required-field': required }"
      >
      <mat-icon matSuffix class="emds-find-control-icon clickable">alarm</mat-icon>
    </mat-form-field>
  </ng-template>
  <div class="incorrect-input" *ngIf="required && form?.submitted && error">
    {{ error }}
  </div>
</div>
